function Q1ObjectivesPolicesScorecard2024() {
	return (
		<div className="overflow-x-auto not-prose">
			{/* Personal Lines */}
			<div className="overflow-x-auto">
				<table className="is-financial-table tabular-nums min-w-[700px] w-full border-collapse table-auto">
					<thead>
						<tr className="text-right text-[#4B7B9D] no-hover">
							<td></td>

							<th colSpan={2} className="!border-r">
								<span className="block leading-[1rem] mb-3">Three Months Ended March 31,</span>
							</th>
							<th colSpan={3}>
								<span className="block leading-[1rem]">Years Ended December 31,</span>
							</th>
							<td></td>
						</tr>
						<tr className="text-right no-hover text-[#4B7B9D]">
							<td></td>
							<th>Target</th>
							<th>2025</th>
							<th>2024</th>
							<th>2023</th>
							<th>2022</th>
							<th>
								5 Years<sup>1</sup>
							</th>
							<th>
								10 Years<sup>1</sup>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr className="no-hover">
							<td className="font-bold font-trade text-[#767727] no-hover">Underwriting margin:</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">
								Progressive<sup>2</sup>
							</td>
							<td>4%</td>
							<td>14.0%</td>
							<td>11.2%</td>
							<td>5.1%</td>
							<td>4.2%</td>
							<td>7.6%</td>
							<td>7.6%</td>
						</tr>
						<tr>
							<td className="cell-indent">
								Industry<sup>3</sup>
							</td>
							<td>na</td>
							<td>||||||||</td>
							<td>||||||||</td>
							<td>(4.6)%</td>
							<td>(11.8)%</td>
							<td>(1.4)%</td>
							<td>(1.7)%</td>
						</tr>
						<tr className="no-hover">
							<td className="font-bold font-trade text-[#767727] no-hover] border-r-[1px] border-black/25" colSpan={2}>
								Net premiums written growth:
							</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">Progressive</td>
							<td>(a)</td>
							<td>17%</td>
							<td>21%</td>
							<td>20%</td>
							<td>10%</td>
							<td>15%</td>
							<td>15%</td>
						</tr>
						<tr>
							<td className="cell-indent">
								Industry<sup>3</sup>
							</td>
							<td>na</td>
							<td>||||||||</td>
							<td>||||||||</td>
							<td>14%</td>
							<td>6%</td>
							<td>5%</td>
							<td>6%</td>
						</tr>
						<tr className="no-hover">
							<td className="font-bold font-trade text-[#767727] no-hover">Policies in force growth:</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">Personal Lines</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent--2">Agency – auto </td>
							<td>(a)</td>
							<td>18%</td>
							<td>17%</td>
							<td>7%</td>
							<td>(1)%</td>
							<td>7%</td>
							<td>8%</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Direct – auto</td>
							<td>(a)</td>
							<td>25%</td>
							<td>25%</td>
							<td>10%</td>
							<td>6%</td>
							<td>12%</td>
							<td>12%</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Special lines</td>
							<td>(a)</td>
							<td>9%</td>
							<td>9%</td>
							<td>7%</td>
							<td>5%</td>
							<td>7%</td>
							<td>5%</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Property</td>
							<td>(a)</td>
							<td>11%</td>
							<td>14%</td>
							<td>9%</td>
							<td>3%</td>
							<td>10%</td>
							<td>nm</td>
						</tr>
						<tr>
							<td className="cell-indent">Commercial Lines </td>
							<td>(a)</td>
							<td>6%</td>
							<td>4%</td>
							<td>5%</td>
							<td>8%</td>
							<td>9%</td>
							<td>8%</td>
						</tr>
						<tr>
							<td className="font-bold !text-wrap">Companywide premiums-to-surplus ratio</td>
							<td>(b)</td>
							<td>na</td>
							<td>2.7</td>
							<td>2.8</td>
							<td>2.9</td>
							<td>na</td>
							<td>na</td>
						</tr>
						<tr className="no-hover">
							<td className="font-bold font-trade text-[#767727] no-hover">Investment allocation:</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">Group I</td>
							<td>≤ 25%</td>
							<td>5%</td>
							<td>6%</td>
							<td>7%</td>
							<td>10%</td>
							<td>na</td>
							<td>na</td>
						</tr>
						<tr>
							<td className="cell-indent">Group II</td>
							<td>≥ 75%</td>
							<td>95%</td>
							<td>94%</td>
							<td>93%</td>
							<td>90%</td>
							<td>na</td>
							<td>na</td>
						</tr>
						<tr>
							<td className="font-bold">Debt-to-total capital ratio</td>
							<td>&lt; 30%</td>
							<td>19.2%</td>
							<td>21.2%</td>
							<td>25.4%</td>
							<td>28.7%</td>
							<td>na</td>
							<td>na</td>
						</tr>
						<tr className="no-hover">
							<td className="font-bold font-trade text-[#767727] no-hover text-wrap border-r-[1px] border-black/25" colSpan={2}>
								Return on average common shareholders’
								<br /> equity – trailing 12 months:
							</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">Net income</td>
							<td>(c)</td>
							<td>34.2%</td>
							<td>35.5%</td>
							<td>22.9%</td>
							<td>4.4%</td>
							<td>24.4%</td>
							<td>23.6%</td>
						</tr>
						<tr>
							<td className="cell-indent">Comprehensive income (loss)</td>
							<td>(c)</td>
							<td>39.3%</td>
							<td>36.4%</td>
							<td>30.0%</td>
							<td>(13.5)%</td>
							<td>22.4%</td>
							<td>22.8%</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div className="mt-10 text-[.85rem] tabular-nums">
				<p className="mb-0 no-animate">(a) Grow as fast as possible, constrained only by our profitability objective and our ability to provide high-quality customer service.</p>
				<p className="mb-0 no-animate">(b) Determined separately for each insurance subsidiary.</p>
				<p className="mb-0 no-animate">(c) Progressive does not have a predetermined target for return on average common shareholders&apos; equity.</p>
				<p className="mb-0 no-animate">na = not applicable.</p>
				<p className="mb-0 no-animate">nm = not meaningful; personal property business written by Progressive prior to April 2015 was negligible.</p>
			</div>
			<div className="text-[.85rem] tabular-nums">
				<p className="mb-0 no-animate">
					<sup>1</sup> Represents results over the respective time period; growth represents average annual compounded rate of increase (decrease) as of
					<br /> December 31, 2024.
				</p>
				<p className="mb-0 no-animate">
					<sup>2</sup> Expressed as a percentage of net premiums earned. Underwriting profit (loss) is calculated by subtracting losses and loss adjustment expenses, policy acquisition costs, and other underwriting expenses from the total of net premiums earned and fees and other revenues.
				</p>
				<p className="mb-0 no-animate">
					<sup>3</sup> Industry results represent private passenger auto insurance market data as reported by A.M. Best Company, Inc. The industry underwriting margin excludes the effect of policyholder dividends. Final comparable industry data for 2024 will not be available until our third quarter 2025 report. The 5- and 10-year growth rates are presented on a one-year lag basis for the industry.
				</p>
			</div>
		</div>
	);
}

export default Q1ObjectivesPolicesScorecard2024;
